import ApiConnector from "../apiConnector";
import { TeamStory } from "../entities/teamStory";

class TeamStoryDataFetcher {
    private readonly apiConnector: ApiConnector;

    constructor(baseURL: string) {
        this.apiConnector = new ApiConnector(baseURL);
    }

    public async getTeamStory(templateIdOrTargetId: string): Promise<TeamStory[]> {
        if (isGuid(templateIdOrTargetId))
            return this.apiConnector.get(`/teamstory/template/${templateIdOrTargetId}/records`);
        else return this.apiConnector.get(`/teamstory/target/${templateIdOrTargetId}/records`);
    }

    public async getTemplate(templateId: string): Promise<TeamStory> {
        return this.apiConnector.get(`/teamstory/${templateId}`);
    }

    public async getRecord(recordId: string): Promise<TeamStory> {
        return this.apiConnector.get(`/teamstory/detail/${recordId}`);
    }

    public async updateTeamStory(newTeamStoryData: TeamStory) {
        return this.apiConnector.put("/teamstory", newTeamStoryData);
    }

    public async createTeamStory(targetCode: string, newTeamStoryData: TeamStory) {
        return this.apiConnector.post(`/teamstory/${targetCode}`, newTeamStoryData);
    }

    public async deleteTeamStory(recordId: string) {
        return this.apiConnector.delete(`/teamstory/${recordId}`);
    }
}

function isGuid(input: string): boolean {
    const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return guidPattern.test(input);
}

export default TeamStoryDataFetcher;
